var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4172 8.41908C11.4772 7.66336 12.1685 6.42373 12.1685 5.02265C12.1685 2.72057 10.3023 0.85437 8.00024 0.85437C5.69816 0.85437 3.83196 2.72057 3.83196 5.02265C3.83196 6.42373 4.52323 7.66336 5.58331 8.41908C2.82629 9.40985 0.854614 12.0475 0.854614 15.1456H2.04555C2.04555 11.8569 4.71155 9.19093 8.00024 9.19093C11.2889 9.19093 13.9549 11.8569 13.9549 15.1456H15.1459C15.1459 12.0475 13.1742 9.40985 10.4172 8.41908ZM10.9776 5.02265C10.9776 6.66699 9.64458 7.99999 8.00024 7.99999C6.3559 7.99999 5.02289 6.66699 5.02289 5.02265C5.02289 3.37831 6.3559 2.04531 8.00024 2.04531C9.64458 2.04531 10.9776 3.37831 10.9776 5.02265Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7b5fdfaa61782c2a46a09f7e16153034.svg";
export { ForwardRef as ReactComponent };